function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

export default removeEventListener;


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/removeEventListener.js
// module id = 2603
// module chunks = 121